import AppointmentAudioFile from '../assets/audio/052533812-simple-notification-alert-02.mp3';
import CallAudioFile from '../assets/audio/045047813-ringing-complete-sound-4-notif-high.mp3';
import ChatAudioFile from '../assets/audio/040458664-positive-multimedia-ding-2-mal.mp3';
import CustomerArrivalAudioFile from '../assets/audio/040458666-positive-multimedia-ding-3-mal-high.mp3';
import MidCallJoinAudioFile from '../assets/audio/052533816-simple-notification-alert-01.mp3';
import HandoffAudioFile from '../assets/audio/124952073-little-bell-ding-02.wav';

import utilsService from './utilsService';
import VIDABOO_CONSTANTS from '../config/consts';

const service = {};

service.init = () => {
  if (!VIDABOO_CONSTANTS.NATIVE_APP && utilsService.getIsInExpertHome()) {
    service.fixAudioAtStartBug();
  }
};

service.fixAudioAtStartBug = () => {
  //This bug causes audio to not be played unless user clicks and starts an audio.
  window.addEventListener('click', service.handleAudioAutoPlay);
};

service.handleAudioAutoPlay = () => {
  try {
    const audioObj = service.playOrGetAudioFile(
      VIDABOO_CONSTANTS.AUDIO_SOUND_TYPES.CHAT_AUDIO,
      true,
    );
    const playPromise = audioObj.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          audioObj.pause();
        })
        .catch((error) => {
          console.debug('Error while auto playing: ', error);
        });
    }
    if (!VIDABOO_CONSTANTS.NATIVE_APP) {
      window.removeEventListener('click', service.handleAudioAutoPlay);
    }
  } catch (error) {
    console.debug('Error:', error);
  }
};

service.playOrGetAudioFile = (
  type = '',
  getAudioFile = false,
  propertyObj = {},
) => {
  let audioObj = {};
  switch (type) {
    case VIDABOO_CONSTANTS.AUDIO_SOUND_TYPES.APPOINTMENT_REMINDER_AUDIO:
      audioObj = new Audio(AppointmentAudioFile);
      break;
    case VIDABOO_CONSTANTS.AUDIO_SOUND_TYPES.CALL_AUDIO:
      audioObj = new Audio(CallAudioFile);
      break;
    case VIDABOO_CONSTANTS.AUDIO_SOUND_TYPES.CHAT_AUDIO:
      audioObj = new Audio(ChatAudioFile);
      break;
    case VIDABOO_CONSTANTS.AUDIO_SOUND_TYPES.CUSTOMER_ARRIVAL_AUDIO:
      audioObj = new Audio(CustomerArrivalAudioFile);
      break;
    case VIDABOO_CONSTANTS.AUDIO_SOUND_TYPES.MID_CALL_JOIN_AUDIO:
      audioObj = new Audio(MidCallJoinAudioFile);
      break;
    case VIDABOO_CONSTANTS.AUDIO_SOUND_TYPES.HANDOFF_AUDIO:
      audioObj = new Audio(HandoffAudioFile);
      break;
    default:
      audioObj = new Audio(ChatAudioFile);
  }

  try {
    for (const [audioProperty, audioPropertyValue] of Object.entries(
      propertyObj,
    )) {
      audioObj[audioProperty] = audioPropertyValue;
    }
    if (getAudioFile) {
      return audioObj;
    } else {
      const playPromise = audioObj.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            //auto play started
          })
          .catch((error) => {
            console.debug(`Unable to play audio for ${type}, Error: `, error);
          });
      }
    }
  } catch (error) {
    console.debug(`Unable to play audio for ${type}, Error: `, error);
  }
};

service.init();
const audioFileService = {...service};
export default audioFileService;
